import { api, ApiFehler, fehlerText, token } from '../api.js';
import { h, meldung, setzeMeldung } from '../dom.js';
import { navigiere } from '../router.js';
import { entferne, lies, schreibe } from '../speicher.js';

/**
 * Auswertung und Druckseite brauchen kein Testgerät: Wer nur auswerten oder
 * Aufkleber drucken will, gibt den Zugangscode ein und taucht in der Auswertung nicht auf.
 */
/** Lehnte der Server das Token dieses Geräts auf Auswertung oder Druckseite ab? */
let geraetAbgelehnt = false;

export async function hatZugang(): Promise<boolean> {
  if ((await lies('token:auswertung')) !== undefined) return true;
  return !geraetAbgelehnt && (await token()) !== undefined;
}

/**
 * Lehnt der Server das Token ab (401), es vergessen bzw. als abgelehnt merken und
 * das Formular zeigen. Gesendet wird zuerst der Zugang, sonst das Geräte-Token.
 */
export async function zugangAbgelehnt(fehler: unknown): Promise<boolean> {
  if (!(fehler instanceof ApiFehler) || fehler.status !== 401) return false;
  if ((await lies('token:auswertung')) !== undefined) await entferne('token:auswertung');
  else geraetAbgelehnt = true;
  navigiere(location.pathname + location.search, true);
  return true;
}

export function zugangsFormular(ziel: HTMLElement, titel: string): void {
  const status = meldung();
  const code = h('input', {
    id: 'zugang-code',
    name: 'zugangscode',
    type: 'text',
    required: true,
    autocomplete: 'off',
    autocapitalize: 'none',
    spellcheck: 'false',
    'aria-describedby': 'zugang-hilfe',
  });
  const absenden = h('button', { type: 'submit', class: 'knopf knopf-primaer' }, 'Öffnen');
  const formular = h(
    'form',
    { class: 'formular', novalidate: true },
    h(
      'div',
      { class: 'feld' },
      h('label', { for: 'zugang-code' }, 'Zugangscode'),
      code,
      h('p', { id: 'zugang-hilfe', class: 'hilfe' }, 'Steht in der Testanleitung. Dieser Browser wird dafür nicht als Testgerät angelegt.'),
    ),
    absenden,
    status,
  );
  formular.addEventListener('submit', (e) => {
    e.preventDefault();
    void (async () => {
      const wert = code.value.trim();
      code.toggleAttribute('aria-invalid', !wert);
      if (!wert) {
        setzeMeldung(status, 'Bitte den Zugangscode eingeben.', 'fehler');
        code.focus();
        return;
      }
      absenden.disabled = true;
      absenden.setAttribute('aria-busy', 'true');
      setzeMeldung(status, 'Wird geprüft …');
      try {
        const antwort = await api<{ token: string }>('/api/zugang', { json: { zugangscode: wert }, modus: null });
        await schreibe('token:auswertung', antwort.token);
        geraetAbgelehnt = false;
        navigiere(location.pathname + location.search, true);
      } catch (fehler) {
        absenden.disabled = false;
        absenden.removeAttribute('aria-busy');
        if (fehler instanceof ApiFehler && fehler.status === 401) code.setAttribute('aria-invalid', 'true');
        setzeMeldung(status, fehlerText(fehler), 'fehler');
      }
    })();
  });
  ziel.append(
    h('h1', {}, titel),
    h('p', { class: 'einleitung' }, 'Für die Auswertung und die QR-Aufkleber genügt der Zugangscode.'),
    formular,
    h('p', { class: 'leise' }, 'Für die Prüfungen an diesem Gerät stattdessen ', h('a', { href: '/einrichtung' }, 'das Gerät einrichten'), '.'),
  );
}
